"use strict";
exports.__esModule = true;
exports.PopinTheme = void 0;
var PopinTheme;
(function (PopinTheme) {
    PopinTheme["yellow"] = "yellow";
    PopinTheme["green"] = "green";
    PopinTheme["pale_blue"] = "pale-blue";
    PopinTheme["blue"] = "blue";
    PopinTheme["darkish_blue"] = "darkish-blue";
    PopinTheme["light_turquoise"] = "light-turquoise";
    PopinTheme["turquoise"] = "turquoise";
})(PopinTheme = exports.PopinTheme || (exports.PopinTheme = {}));
//# sourceMappingURL=popin.js.map